/* eslint-disable no-console */
import axios from "axios";
import secureStorage from '../controllers/secureStorage.js';

const serverMaintenanceMessage = "Server Under Maintenance. Please contact Baxter XI admin.";

function compactErrorMessages(value) {
    if (value == undefined || value == null || value === "") return [];
    if (Array.isArray(value)) return value.reduce((messages, item) => messages.concat(compactErrorMessages(item)), []);
    if (typeof value === "object") {
        return compactErrorMessages(value.error)
            .concat(compactErrorMessages(value.errors))
            .concat(compactErrorMessages(value.message))
            .concat(compactErrorMessages(value.full_messages));
    }
    return [String(value)];
}

function responseErrorMessage(error) {
    var errors = [];
    if (error && error.response && error.response.data != undefined) {
        errors = compactErrorMessages(error.response.data);
    }

    if (errors.length == 0) {
        if (error && error.response && error.response.statusText != undefined && error.response.statusText != "" && error.response.statusText != null) errors.push(error.response.statusText)
        if (error && error.error != undefined && error.error != "" && error.error != null) errors.push(error.error)
        if (error && error.message != undefined && error.message != "" && error.message != null) errors.push(error.message)
    }

    return errors.join(' - ');
}

function forceLogout() {
    secureStorage.setItem("loggedIn", false);
    secureStorage.setItem("accessToken", null);
    secureStorage.setItem("refreshToken", null);
    secureStorage.setItem("sessionId", null);
    location.assign(location.origin);
}

var HTTPRequest = {
    async getRequest(endPoint, parameters, woToken, isFile){
        var response_data;
        var header = {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"}
        if(woToken == undefined){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web",'ip':secureStorage.getItem("ipAddress") }
        }

        if(isFile == "1"){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File",'ip':secureStorage.getItem("ipAddress") }
        }
        
        await axios({
            method: 'get',
            url: endPoint,
            headers: header,
            params: parameters
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        //eslint-disable-next-line
                        console.log("Request ka ulit")

                        await HTTPRequest.getRequest(endPoint, parameters, woToken)
                    } else {
                        response_data = {error: "Cannot get new access token"}
                    }
                } else {
                    var errors = [];
                    if (error.response.data!=undefined && error.response.data.error != undefined) {
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            forceLogout()
                        } else if(error.response.data.error == "Invalid IP for Access Token"){
                            alert("Invalid Access Token. Please login again.")
                            forceLogout()
                        }
                        errors.push(error.response.data.error)
                    } else{
                        if (error.response.statusText != undefined && error.response.statusText != "" && error.response.statusText != null) errors.push(error.response.statusText)
                        if (error.error != undefined && error.error != "" && error.error != null) errors.push(error.error)
                        if (error.message != undefined && error.message != "" && error.message != null) errors.push(error.message)
                    }
                    response_data = {error: errors.join(' - ')}
                }
              });

        var developerMode = secureStorage.getItem("developerMode")
        if (developerMode != true) {
            if(endPoint.includes("system_module_categories") || endPoint.includes("access_rights")){
                await axios({
                    method: 'PUT',
                    url: endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web",'ip':secureStorage.getItem("ipAddress") },
                }).then(function () {

                }).catch(async function () {
                    var regex = /.*login$/;

                    if (!regex.test(location.href)) {
                        alert("Session is already expired. Please login again.");
                        forceLogout();
                    }
                });
            }

        }

        return response_data
    },

    async getRequestReport(endPoint, parameters, woToken){
        var response_data;
        var header = {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"}
        if(woToken == undefined){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File",'ip':secureStorage.getItem("ipAddress") }
        }
        await axios({
            method: 'get',
            url: endPoint,
            headers: header,
            params: parameters
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        //eslint-disable-next-line
                        console.log("Request ka ulit")

                        await HTTPRequest.getRequest(endPoint, parameters, woToken)
                    } else {
                        response_data = {error: "Cannot get new access token"}
                    }
                } else {
                    var errors = [];
                    if (error.response.data!=undefined && error.response.data.error != undefined) {
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            forceLogout()
                        } else if(error.response.data.error == "Invalid IP for Access Token"){
                            alert("Invalid Access Token. Please login again.")
                            forceLogout()
                        }
                        errors.push(error.response.data.error)
                    } else{
                        if (error.response.statusText != undefined && error.response.statusText != "" && error.response.statusText != null) errors.push(error.response.statusText)
                        if (error.error != undefined && error.error != "" && error.error != null) errors.push(error.error)
                        if (error.message != undefined && error.message != "" && error.message != null) errors.push(error.message)
                    }
                    response_data = {error: errors.join(' - ')}
                }
              });

        var developerMode = secureStorage.getItem("developerMode")
        if (developerMode != true) {
            if(endPoint.includes("system_module_categories") || endPoint.includes("access_rights")){
                await axios({
                    method: 'PUT',
                    url: endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File",'ip':secureStorage.getItem("ipAddress") },
                }).then(function () {

                }).catch(async function () {
                    var regex = /.*login$/;

                    if (!regex.test(location.href)) {
                        alert("Session is already expired. Please login again.");
                        forceLogout();
                    }
                });
            }

        }

        return response_data
    },
    
    async postRequest(endPoint, parameters, requestBody, woToken, isFile){
        var response_data;
        var header = {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"}
        if(isFile == "1"){
            header = {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"}
        }
        
        if(woToken == undefined){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") }
            if(isFile == "1"){
                header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress") }
            }
        }
        await axios({
            method: 'post',
            url: endPoint,
            headers: header,
            data: requestBody,
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        //eslint-disable-next-line
                        console.log("Request ka ulit")
                        await HTTPRequest.postRequest(endPoint, parameters, requestBody, woToken)
                    } else {
                        response_data = {error: "Cannot get new access token"}
                    }
                } else {
                    if (error.response.data!=undefined && error.response.data.error != undefined) {
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            forceLogout()
                        } else if(error.response.data.error == "Invalid IP for Access Token"){
                            alert("Invalid Access Token. Please login again.")
                            forceLogout()
                        }
                    }
                    response_data = {error: responseErrorMessage(error)}
                    // CNC-002: preserve a server-supplied machine-readable
                    // error_code (e.g. STALE_DOCUMENT for a concurrency conflict)
                    // so callers can branch on it instead of parsing message text.
                    if (error.response && error.response.data && error.response.data.error_code != undefined) {
                        response_data.error_code = error.response.data.error_code
                    }
                }
            });
        return response_data;
    },

    async putRequest(endPoint, parameters, requestBody, woToken){
        var response_data;
        var header = {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"}
        if(woToken == undefined){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") }
        }
        await axios({
            method: 'put',
            url: endPoint,
            headers: header,
            data: requestBody,
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                console.log(error)
                secureStorage.setItem("serverRunning", true)
                if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        //eslint-disable-next-line
                        //console.log("Request ka ulit")
                        await HTTPRequest.putRequest(endPoint, parameters, requestBody, woToken)
                    } else {
                        response_data = {error: "Cannot get new access token"}
                    }
                } else {
                    var errors = [];
                    // console.log(error.response.data.error)
                    if (error.response.data!=undefined && error.response.data.error != undefined) {
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            forceLogout()
                        } else if(error.response.data.error == "Invalid IP for Access Token"){
                            alert("Invalid Access Token. Please login again.")
                            forceLogout()
                        }
                        errors.push(error.response.data.error)
                    } else {
                        if (error.response.statusText != undefined && error.response.statusText != "" && error.response.statusText != null) errors.push(error.response.statusText)
                        if (error.error != undefined && error.error != "" && error.error != null) errors.push(error.error)
                        if (error.message != undefined && error.message != "" && error.message != null) errors.push(error.message)
                    }
                    response_data = {error: errors.join(' - ')}

                    // response_data = {error: error.response.data.error}
                   // console.log(error.response.statusText)
                    // alert(error.response.data.statusText)
                }
            });
        return response_data;
    },

    async destroyRequest(endPoint, parameters, requestBody, woToken){
        var response_data;
        var header = {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"}
        if(woToken == undefined){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") }
        }
        await axios({
            method: 'delete',
            url: endPoint,
            headers: header,
            data: requestBody,
            })
            .then(function (response) {
                secureStorage.setItem("serverRunning", true)
                response_data = response.data
            })
            .catch(async function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                } else if(error.response.status == 401){
                    var auth_response = await HTTPRequest.authenticate(endPoint)
                    if(auth_response["status"] == "Ok") {
                        await HTTPRequest.destroyRequest(endPoint, parameters, requestBody, woToken)
                    } else {
                        response_data = {error: "Cannot get new access token"}
                    }
                } else {
                    var errors = [];
                    if (error.response.data!=undefined && error.response.data.error != undefined) {
                        if(error.response.data.error == "Session expired"){
                            alert("Session is already expired. Please login again.")
                            forceLogout()
                        } else if(error.response.data.error == "Invalid IP for Access Token"){
                            alert("Invalid Access Token. Please login again.")
                            forceLogout()
                        }
                        errors.push(error.response.data.error)
                    } else {
                        if (error.response.statusText != undefined && error.response.statusText != "" && error.response.statusText != null) errors.push(error.response.statusText)
                        if (error.error != undefined && error.error != "" && error.error != null) errors.push(error.error)
                        if (error.message != undefined && error.message != "" && error.message != null) errors.push(error.message)
                    }
                    response_data = {error: errors.join(' - ')}
                }
            });
        return response_data;
    },

    async authenticate(endPoint){
        // eslint-disable-next-line
        var response_data;
        var bodyFormData = new FormData();
        bodyFormData.set('email', secureStorage.getItem("email"));
        bodyFormData.append('refresh_token', secureStorage.getItem("refreshToken"));
        bodyFormData.append('grant_type', 'refresh_token');
        await axios({
            method: 'post',
            url: endPoint.split("/api")[0] + '/oauth/token',
            headers: {"Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
            data: bodyFormData,
            })
            .then(function (response) {
                response_data = response.data
                secureStorage.setItem("accessToken", response_data["access_token"]);
                secureStorage.setItem("refreshToken", response_data["refresh_token"]);
                secureStorage.setItem("serverRunning", true)
                response_data = {status: "Ok"}
            })
            .catch(function (error) {
                secureStorage.setItem("serverRunning", true)
                if (error == "Error: Network Error") {
                  response_data = {error: "Network Error"}
                } else if (error.response.status > 500) {
                  secureStorage.setItem("serverRunning", false)
                  response_data = { error: serverMaintenanceMessage }
                  console.log(serverMaintenanceMessage)
                }
                // eslint-disable-next-line

                // console.log("I AM HERE!!!! <<<<")
                response_data = {error: "Error"}
                console.log(error)
            });

        return response_data;
    },

    async getRequestThirdParty(endPoint, parameters, woToken){
        var header = {'Request-Source':"BXI-Web"}
        if(woToken == undefined){
            header = {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") }
        }
        var config = {
            method: 'get',
            url: endPoint.replace(/['"]+/g, ''),
            headers: header,
        };

        // console.log(config);
        var response_data;
        await axios(config)
            .then(function (response) {
                response_data = response.data
            })
            .catch(function () {
                response_data = []
                //console.log(error)
            });

        return response_data
    },
}

export default HTTPRequest;
